/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_Col_ActionsInputs */

const vi_api_keys_col_actions = /** @type {(inputs: Api_Keys_Col_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thao tác`)
};

/**

* @param {Api_Keys_Col_ActionsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_col_actions = /** @type {((inputs?: Api_Keys_Col_ActionsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Col_ActionsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_col_actions(inputs)
});